<main id="content-page" style="margin: 20px 0px">
    <app-header-ad [position]="'top'"></app-header-ad>
    <div class="row article-row">
        <div class="col-lg-12 col-md-12 col-sm-12">
            <div class="article-wrap">
                <div class="article-inner-container" style="margin-left: 15px; padding-right: 15px">
                    <h1>Foundations of Law - In-depth online summaries of major law topics <i *ngIf="!courses"
                            style="color: #337ab7; font-weight: 800; font-size: 22px; margin-left: 20px"
                            class="fa fa-spinner fa-spin"></i></h1>
                    <p>
                        Lawshelf Foundations of Law is an organized series of articles written by attorneys on a variety
                        of legal topics. Foundations of Law, with examples, self tests and citations embedded, is
                        designed to clearly convey and teach legal rules and concepts in a variety of legal fields.
                        While sufficiently advanced to constitute college-level law-based coursework, the courseware is
                        also accessible to the layperson and to the professional who wishes to gain foundational
                        knowledge in particular areas of law.
                    </p>
                </div>
                <div>
                    <ul *ngIf="courses">
                        <app-courseware-topic (showContentEntry)="onShowContentEntryClicked($event)"
                            *ngFor="let aTopic of courses" [topic]="aTopic" [levelOneAlias]="levelOneAlias"
                            [levelTwoAlias]="levelTwoAlias"></app-courseware-topic>
                    </ul>
                </div>
            </div>
        </div>
    </div>
    <app-header-ad [position]="'bottom'"></app-header-ad>
</main>